import {
  SUGERENCIA_ERROR,
  SUGERENCIA_LOADING,
  SUGERENCIA_SUCCESS,
  SUGERENCIA_RESET,
} from "../../ActionTypes";

import axiosLogin from "global/helpers/axiosLogin";

export const wsPostSugerencia = (sugerencia) => (dispatch) => {
  dispatch({
    type: SUGERENCIA_LOADING,
  });

 axiosLogin().then(respuesta => {
  respuesta
  .post("/shared/Sugerencia/sugerencia", sugerencia)
  .then((res) => {
    dispatch({
      type: SUGERENCIA_SUCCESS,
      payload: res.data,
    });
  })
  .catch((err) => {
    let error = {
      detail: err.response
        ? err.response.data
        : "Error al contactar el server.",
      origen: "portal",
    };

    dispatch({
      type: SUGERENCIA_ERROR,
      payload: error,
    });
  });
 } )
};

export const sugerenciaReset = () => (dispatch) => {
  dispatch({
    type: SUGERENCIA_RESET,
  });
};
